var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmWithCross(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.469v17.187C18 23.951 16.993 25 15.75 25H2.25C1.007 25 0 23.95 0 22.656V5.47c0-1.295 1.007-2.344 2.25-2.344H6C6 1.402 7.346 0 9 0s3 1.402 3 3.125h3.75c1.243 0 2.25 1.05 2.25 2.344zM9 1.953c-.621 0-1.125.525-1.125 1.172 0 .647.504 1.172 1.125 1.172s1.125-.525 1.125-1.172c0-.647-.504-1.172-1.125-1.172zm4.5 5.567v-.977a.3.3 0 00-.082-.207.276.276 0 00-.2-.086H4.782a.276.276 0 00-.199.086.3.3 0 00-.082.207v.977a.3.3 0 00.082.207.276.276 0 00.2.085h8.437c.074 0 .146-.03.199-.085a.3.3 0 00.082-.207z",
    fill: "#2A848E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.316 13.056L17.03 9.771l3.286-3.286a.876.876 0 00-1.24-1.239l-3.285 3.286-3.285-3.286a.876.876 0 00-1.239 1.24l3.286 3.285-3.286 3.285a.877.877 0 101.239 1.239l3.285-3.286 3.286 3.286a.876.876 0 101.239-1.239z",
    fill: "#FB4856"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmWithCross);
export default ForwardRef;